import React, { createContext, useContext, useState } from "react";

// Define the shape of your filters
interface Filters {
    eventTypes?: string[];
    startDate?: string | null;
    endDate?: string | null;
    // Add other filter fields here if needed
}

// Define the context type using the Filters interface
type FilterContextType = {
    filters: Filters;
    setFilters: React.Dispatch<React.SetStateAction<Filters>>;
};

// Provide a default value that conforms to FilterContextType
const defaultFilterContext: FilterContextType = {
    filters: {},
    setFilters: () => { },
};

export const DetailsFilterContext = createContext<FilterContextType>(defaultFilterContext);

interface FilterProviderProps {
    children: React.ReactNode;
}

export const DetailsFilterProvider: React.FC<FilterProviderProps> = ({ children }) => {
    const [filters, setFilters] = useState<Filters>({});

    return (
        <DetailsFilterContext.Provider value={{ filters, setFilters }}>
            {children}
        </DetailsFilterContext.Provider>
    );
};

export const useDetailsFilters = () => {
    const context = useContext(DetailsFilterContext);
    if (!context) {
        throw new Error("useFilters must be used within a FilterProvider");
    }
    return context;
};